import React, { useState } from 'react';

export default function QuestionComments({ questionId }) {
  const [comments, setComments] = useState([
    { id: 1, author: 'Luca (Kaufmann EFZ)', text: 'Eselsbrücke für die Buchungssätze: Soll an Haben!', likes: 12 },
    { id: 2, author: 'Nina', text: 'Achtung bei Frage 3, die Formel wird oft in der Prüfung abgefragt.', likes: 5 }
  ]);
  const [newComment, setNewComment] = useState('');

  const handleAddComment = (e) => {
    e.preventDefault();
    if (!newComment.trim()) return;
    setComments([
      ...comments,
      { id: Date.now(), author: 'Du', text: newComment, likes: 0 }
    ]);
    setNewComment('');
  };

  const handleLike = (id) => {
    setComments(comments.map(c => c.id === id ? { ...c, likes: c.likes + 1 } : c));
  };

  return (
    <div className="bg-[#141c2e] border border-slate-800 rounded-2xl p-6 my-6 font-sans">
      <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2">
        💬 Eselsbrücken & Diskussionen zu dieser Frage
      </h3>

      <div className="space-y-3 mb-6">
        {comments.map((c) => (
          <div key={c.id} className="bg-[#0b1329] border border-slate-700/60 p-4 rounded-xl flex justify-between items-start gap-4">
            <div>
              <span className="text-xs font-bold text-[#fbbf24]">{c.author}</span>
              <p className="text-sm text-slate-200 mt-1">{c.text}</p>
            </div>
            <button
              onClick={() => handleLike(c.id)}
              className="bg-slate-800 hover:bg-slate-700 text-slate-300 text-xs px-3 py-1.5 rounded-lg border border-slate-700 flex items-center gap-1 cursor-pointer shrink-0"
            >
              👍 {c.likes}
            </button>
          </div>
        ))}
      </div>

      <form onSubmit={handleAddComment} className="flex gap-2">
        <input
          type="text"
          placeholder="Teile deine Eselsbrücke oder stelle eine Frage..."
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          className="flex-1 bg-[#0b1329] border border-slate-700 text-white p-3 rounded-xl text-sm outline-none focus:border-[#fbbf24]"
        />
        <button
          type="submit"
          className="bg-[#22c55e] hover:bg-[#16a34a] text-black font-bold px-4 py-3 rounded-xl text-sm cursor-pointer"
        >
          Senden
        </button>
      </form>
    </div>
  );
}
